// Angular
import {
	Component,
	OnInit,
	ChangeDetectionStrategy,
	OnDestroy,
	ChangeDetectorRef,
	Inject,
	ViewRef
} from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

// Services
import { CommonConFig } from '../../../dung-chung/__model/common_config.model';
import { DungChungService } from '../../../dung-chung/__services/dung-chung.service';

// Date and Moment
import { DatePipe } from '@angular/common';

@Component({
	selector: 'kt-ton-kho-hien-tai-histories',
	templateUrl: './ton-kho-hien-tai-histories.component.html',
	styleUrls: ['../ton-kho-hien-tai.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [DatePipe]
})
export class TonKhoHienTaiHistoriesComponent implements OnInit {
	CONFIG: CommonConFig;
	TonKhoHienTaiHistories: any;
	title = 'LỊCH SỬ THAY ĐỔI THÔNG TIN';
	displayedColumns: string[] = [];
	availableColumns = [
		{ stt: 1, name: 'Warehouse', isShow: true },
		{ stt: 2, name: 'ProductCode', isShow: true },
		{ stt: 3, name: 'ProductName', isShow: true },
		{ stt: 4, name: 'BacthNumber', isShow: true },
		{ stt: 5, name: 'EntryDate', isShow: true },
		{ stt: 6, name: 'QuantityInStock', isShow: true },
		{ stt: 7, name: 'Unit', isShow: true },
		{ stt: 8, name: 'MachineNumber', isShow: true },
		{ stt: 9, name: 'BatchCode', isShow: true },
		{ stt: 10, name: 'BarrelCode', isShow: true },
		{ stt: 11, name: 'QANotes', isShow: true },
		{ stt: 12, name: 'PreviousTags', isShow: true },
		{ stt: 13, name: 'UpdatedTags', isShow: true },
		{ stt: 14, name: 'LastEditedByName', isShow: true },
		{ stt: 15, name: 'LastEditedDate', isShow: true },
	];

	constructor(
		public dialogRef: MatDialogRef<TonKhoHienTaiHistoriesComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		public dialog: MatDialog,
		private cdr: ChangeDetectorRef,
		private service: DungChungService
	) {
		dialogRef.disableClose = true;
	}

	ngOnInit(): void {
		this.initializeConfig();
		this.handleDialogKeydownEvents();
		this.loadData();
		this.setupColumns();
	}

	private initializeConfig(): void {
		this.CONFIG = new CommonConFig();
	}

	private handleDialogKeydownEvents(): void {
		this.dialogRef.keydownEvents().subscribe(event => {
			if (event.key === this.CONFIG.BUTTON_FORM.BACK.KeyCombine.description) {
				this.back();
			}
			this.detectChanges();
		});
	}

	private loadData(): void {
		this.TonKhoHienTaiHistories = this.data.map(_x => JSON.parse(_x));
	}

	private setupColumns(): void {
		this.displayedColumns = this.availableColumns.map(column => column.name);
	}

	detectChanges(): void {
		if (!(this.cdr as ViewRef).destroyed) {
			this.cdr.detectChanges();
		}
	}

	back(): void {
		this.dialogRef.close();
	}

	getTextColor(backgroundColor: string): string {
		// Chuyển màu nền từ mã hex thành RGB
		const bgR = parseInt(backgroundColor.substring(1, 3), 16);
		const bgG = parseInt(backgroundColor.substring(3, 5), 16);
		const bgB = parseInt(backgroundColor.substring(5, 7), 16);

		// Tính độ tương phản
		const contrast = (bgR * 0.299 + bgG * 0.587 + bgB * 0.114);

		// Trả về màu chữ dựa trên độ tương phản
		if (contrast > 128) {
			return '#000000'; // Màu chữ black
		} else {
			return '#ffffff'; // Màu chữ white
		}
	}
}
